
import { useLanguage } from "@/contexts/LanguageContext";
import { useState, useEffect, useRef } from "react";
import StepCard from "./how-it-works/StepCard";
import { SearchIcon3D, ThumbsUpIcon3D, StarIcon3D } from "./how-it-works/ModernIcons";

export default function HowItWorksSection() {
  const { language, t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -100px 0px"
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const getStepDescription = (stepNumber: number) => {
    if (stepNumber === 1) {
      return language === 'ka' 
        ? "მოძებნე ბიზნესები სახელით, კატეგორიით ან ადგილმდებარეობით"
        : language === 'en' 
        ? "Search for businesses by name, category, or location"
        : language === 'ru' 
        ? "Искать бизнес по названию, категории или местоположению"
        : "İşletmeleri ada, kategoriye veya konuma göre arayın";
    } else if (stepNumber === 2) {
      return language === 'ka' 
        ? "გაეცანი რეალურ შეფასებებს და მომხმარებელთა გამოცდილებებს"
        : language === 'en' 
        ? "Browse real ratings and user experiences"
        : language === 'ru' 
        ? "Просматривайте реальные оценки и отзывы"
        : "Gerçek değerlendirmeleri ve kullanıcı deneyimlerini görün";
    } else {
      return language === 'ka' 
        ? "გააზიარე შენი გამოცდილება და დაეხმარე სხვებს"
        : language === 'en' 
        ? "Share your experience and help others"
        : language === 'ru' 
        ? "Поделитесь своим опытом и помогите другим"
        : "Deneyiminizi paylaşın ve başkalarına yardımcı olun";
    }
  };

  return (
    <section ref={sectionRef} className="bg-secondary py-8">
      <div className="section-container py-4">
        <h2 className="mb-8 text-center text-2xl font-bold">{t("howItWorks.title")}</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 max-w-4xl mx-auto">
          <StepCard
            stepNumber={1}
            title={t("howItWorks.step1")}
            description={getStepDescription(1)}
            icon={<SearchIcon3D />}
            animationDirection="left"
            delay={0}
            isVisible={isVisible}
          />
          
          <StepCard
            stepNumber={2}
            title={t("howItWorks.step2")}
            description={getStepDescription(2)}
            icon={<ThumbsUpIcon3D />}
            animationDirection="right"
            delay={200}
            isVisible={isVisible}
          />
          
          <StepCard
            stepNumber={3}
            title={t("howItWorks.step3")}
            description={getStepDescription(3)}
            icon={<StarIcon3D />}
            animationDirection="left"
            delay={400}
            isVisible={isVisible}
          />
        </div>
      </div>
    </section>
  );
}
